import "../assets/TextLink.css";
import { jsxs as p, jsx as c } from "preact/jsx-runtime";
import { c as _ } from "./index.2w0W-O47.js";
const h = "_link_at2hh_1", k = "_disabled_at2hh_13", r = {
  link: h,
  disabled: k
}, $ = ({
  text: s,
  label: e = "",
  href: n = "",
  iconComponent: l,
  iconPosition: a = "left",
  isDisabled: i = !1,
  ...t
}) => /* @__PURE__ */ p(
  "a",
  {
    "data-testid": "pulse-icon-link",
    ...t,
    class: _([
      "pulseTypeStrong",
      r.link,
      i && r.disabled,
      t.class
    ]),
    href: n,
    "aria-label": e || s,
    children: [
      a === "left" && l,
      /* @__PURE__ */ c("span", { children: s }),
      a === "right" && l
    ]
  }
), o = "_link_1phi7_1", b = "_disabled_1phi7_23", d = {
  link: o,
  "step--1": "_step--1_1phi7_18",
  disabled: b
}, T = ({
  text: s = "",
  label: e = "",
  href: n = "",
  sizeStep: l = 0,
  isDisabled: a = !1,
  ...i
}) => /* @__PURE__ */ c(
  "a",
  {
    ...i,
    class: _([
      d.link,
      d[`step-${l}`],
      a && d.disabled,
      i.class
    ]),
    href: n,
    "aria-label": e || s,
    children: /* @__PURE__ */ c("span", { children: s })
  }
);
export {
  $ as I,
  T
};
